import * as React from 'react';
import { pure } from 'recompose';

/* UI */
import TextField from 'material-ui/TextField';

/* Style */
import {
  textInputBox,
  textActiveInputBox,
  textErrorInputBox,
} from '../../../../styles/input.style';

import { TextInputProps, TextInputState } from '../types';

class StateInput extends React.Component<TextInputProps, TextInputState> {
  constructor(props: TextInputProps) {
    super(props);
    this.state = {
      focused: false,
    };
  }

  onFilled = () => {
    // When the input reaches the character limit.
    // TOOD(gemma): Support this in date and alcohol form; and maybe phone.
    // Will also need to check timing; maybe we trigger this on the componentdidupdate or something...
    this.props.onFilled && this.props.onFilled(this.props.id);
  };

  onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = event.target;
    this.props.onChange(this.props.id, value.substring(0, 2).toUpperCase());
  };

  onBlur = () => {
    this.setState({ focused: false });
    this.props.onBlur(this.props.id);
  };

  onFocus = () => {
    this.setState({ focused: true });
  };

  getBoxStyle = () => {
    const { inputBoxStyle, showError } = this.props;
    const { focused } = this.state;

    let boxStyle;
    if (focused) {
      boxStyle = { ...textActiveInputBox };
    } else if (showError) {
      boxStyle = { ...textErrorInputBox };
    } else {
      boxStyle = { ...textInputBox };
    }

    boxStyle.style = { ...boxStyle.style, maxWidth: '40px' };

    // Overwrite 'style' with anything custom that effects all types; focused, error, and default.
    if (inputBoxStyle) {
      boxStyle.style = { ...boxStyle.style, ...inputBoxStyle };
    }

    return boxStyle;
  };

  render() {
    const { input, id, name, floatingLabelText, hintText } = this.props;

    return (
      <TextField
        id={id}
        name={name}
        value={input}
        onBlur={this.onBlur}
        onFocus={this.onFocus}
        onChange={this.onChange}
        floatingLabelText={floatingLabelText}
        hintText={hintText}
        fullWidth
        underlineShow={false}
        {...this.getBoxStyle()}
      />
    );
  }
}

export default pure(StateInput);
